/// <reference path="Assistant.ts" />

namespace TerminalApp {


    export class PurchaseLineAssistant extends Assistant {
        inner = document.createElement("div");
        result_container = document.createElement("div");
        header = document.createElement("div");
        initialized = false;
        callback: (id: SP.PurchaseOrderLineInfo) => void;
        selectedLine: SP.PurchaseOrderLineInfo;
        constructor() {
            super();
            this.header.innerHTML = `
                 <h1>${SP.Localize("sentance_pick_purchase_line")}</h1>
                `;
            //setup sender screen
            this.inner.appendChild(this.header);
            this.inner.append(this.result_container);
            this.container.appendChild(this.inner);
        }

        clear() {
            this.selectedLine = null;
            this.result_container.innerHTML = "";
            this.result_container.style.display = "none";
        }


        async open(lines: SP.PurchaseOrderLineInfo[]) {
            await this.clear();
            this.result_container.innerHTML = "";
            this.container.style.display = "block";



            for (let i = 0; i < lines.length; i++) {
                let t = lines[i];
                this.addLineButton(t);
            }

            this.result_container.style.display = "block";

            await SP.Sounds.Notification.play();
            //await SP.sleep(500);
            Talk(SP.Localize("sentance_multiple_purchase_order_lines_found"));

            // Promise is created only for the close operation.
            return new Promise<SP.PurchaseOrderLineInfo>((callback, reject) => {
                this.callback = callback; 
                return 1;
            });
        }


        close() {
            // When close is called, resolve the Promise.
            if (this.callback) {
                this.callback(this.selectedLine);
                this.callback = null;
            }

            super.close();
        }

        addLineButton(data: SP.PurchaseOrderLineInfo) {
            var c = this.result_container.appendChild(document.createElement("div"))
            c.classList.add("btn", "noselect");

            var action = c.appendChild(document.createElement("span"));
            action.classList.add("action");
            action.innerHTML = "<b>" + data.loc + "</b>";

            c.addEventListener("click", () => {
                this.selectedLine = data;
                this.close();
            });
        }

    }



}